import { ServiceRequest } from "../../api/ServiceRequest";

export class PumpPortRequest extends ServiceRequest {
  protocol?: number;
  baudRate?: number;

  constructor(init?: Partial<PumpPortRequest>) {
    super(init);
    Object.assign(this, init);
  }

  // Getters & Setters
  getProtocol(): number | undefined {
    return this.protocol;
  }
  setProtocol(value: number | undefined): void {
    this.protocol = value;
  }

  getBaudRate(): number | undefined {
    return this.baudRate;
  }
  setBaudRate(value: number | undefined): void {
    this.baudRate = value;
  }
}
